import { render, staticRenderFns } from "./BuildingConfigShowConfigurationCard.vue?vue&type=template&id=735c9a2a"
import script from "./BuildingConfigShowConfigurationCard.vue?vue&type=script&lang=ts"
export * from "./BuildingConfigShowConfigurationCard.vue?vue&type=script&lang=ts"
import style0 from "./BuildingConfigShowConfigurationCard.vue?vue&type=style&index=0&id=735c9a2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports